import * as React from "react";
import { TableCell } from "@mui/material";
import { DataTable, type DataTableColumn } from "@/components/dashboard/DataTable";
import { ReportStatusBadge } from "./ReportStatusBadge";

export interface ReportMetadataRow {
  report_name: string;
  generated_time?: string | null;
  version?: string | null;
  source?: string | null;
  status: string;
}

interface ReportMetadataTableProps {
  reports: ReportMetadataRow[];
}

const notReported = <span style={{ fontStyle: "italic", opacity: 0.6 }}>Not reported by backend</span>;

export function ReportMetadataTable({ reports }: ReportMetadataTableProps): React.JSX.Element {
  const columns: Array<DataTableColumn<ReportMetadataRow>> = [
    {
      key: "report_name",
      label: "Report Name",
      sortable: true,
      sortValue: (row) => row.report_name,
      render: (row) => <TableCell key="report_name">{row.report_name}</TableCell>,
    },
    {
      key: "generated_time",
      label: "Generated Time",
      render: (row) => <TableCell key="generated_time">{row.generated_time ?? notReported}</TableCell>,
    },
    {
      key: "version",
      label: "Version",
      render: (row) => <TableCell key="version">{row.version ?? notReported}</TableCell>,
    },
    {
      key: "source",
      label: "Source",
      render: (row) => <TableCell key="source">{row.source ?? notReported}</TableCell>,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <TableCell key="status">
          <ReportStatusBadge status={row.status} />
        </TableCell>
      ),
    },
  ];

  return (
    <DataTable
      ariaLabel="Report Metadata"
      columns={columns}
      rows={reports}
      getRowKey={(row) => row.report_name}
    />
  );
}
